import React, { forwardRef } from 'react';
export const AccordionHeader = (StyledAccordionHeader) => forwardRef(({ children, ...props }, ref) => {
    return (<StyledAccordionHeader ref={ref} {...props}>
        {children}
      </StyledAccordionHeader>);
});
